<!-- Button -->
@if(user()) {
<ng-container *transloco="let translate;">
    <button mat-icon-button [matMenuTriggerFor]="userActions">
        <span class="relative">
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        </span>
    </button>

    <mat-menu [xPosition]="'before'" #userActions="matMenu">
        <button mat-menu-item>
            <span class="flex flex-col leading-none">
                <span>{{ translate('signed_in_as') }}</span>
                <span class="mt-1.5 text-md font-medium">{{ user()?.login }}</span>
            </span>
        </button>
        <mat-divider class="my-2"></mat-divider>
        <button mat-menu-item [routerLink]="['/profile']">
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            <span>{{ translate('profile') }}</span>
        </button>
        <mat-divider class="my-2"></mat-divider>
        <button mat-menu-item (click)="signOut()">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
            <span>{{ translate('sign_out') }}</span>
        </button>
    </mat-menu>
</ng-container>


}